// extracted by mini-css-extract-plugin
module.exports = {"v-icon":"NsAddressUa_v-icon_1kbiP","nsAddressForm":"NsAddressUa_nsAddressForm_EPAYF","dualColumn":"NsAddressUa_dualColumn_1-GkU","firstCol":"NsAddressUa_firstCol_2mAGj"};